export default __webpack_public_path__ + "static/media/illi6.49c05028.png";